/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Private_DescInputs */

const en_community_private_desc = /** @type {(inputs: Community_Private_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When enabled, visitors must request access to join your community.`)
};

const es_community_private_desc = /** @type {(inputs: Community_Private_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando está habilitado, los visitantes deben solicitar acceso para unirse a tu comunidad.`)
};

const fr_community_private_desc = /** @type {(inputs: Community_Private_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorsqu'il est activé, les visiteurs doivent demander l'accès pour rejoindre votre communauté.`)
};

const de_community_private_desc = /** @type {(inputs: Community_Private_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn diese Option aktiviert ist, müssen Besucher den Zugang anfordern, um deiner Community beizutreten.`)
};

const id_community_private_desc = /** @type {(inputs: Community_Private_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat diaktifkan, pengunjung harus meminta akses untuk bergabung dengan komunitas Anda.`)
};

/** @type {(inputs: Community_Private_DescInputs) => LocalizedString} */
const ja_community_private_desc = en_community_private_desc;

/** @type {(inputs: Community_Private_DescInputs) => LocalizedString} */
const zh_community_private_desc = en_community_private_desc;

/** @type {(inputs: Community_Private_DescInputs) => LocalizedString} */
const ar_community_private_desc = en_community_private_desc;

/** @type {(inputs: Community_Private_DescInputs) => LocalizedString} */
const it_community_private_desc = en_community_private_desc;

/** @type {(inputs: Community_Private_DescInputs) => LocalizedString} */
const ru_community_private_desc = en_community_private_desc;

/** @type {(inputs: Community_Private_DescInputs) => LocalizedString} */
const pt_community_private_desc = en_community_private_desc;

/** @type {(inputs: Community_Private_DescInputs) => LocalizedString} */
const ko_community_private_desc = en_community_private_desc;

/**
* | output |
* | --- |
* | "When enabled, visitors must request access to join your community." |
*
* @param {Community_Private_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_private_desc = /** @type {((inputs?: Community_Private_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Private_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_private_desc(inputs)
	if (locale === "es") return es_community_private_desc(inputs)
	if (locale === "fr") return fr_community_private_desc(inputs)
	if (locale === "de") return de_community_private_desc(inputs)
	if (locale === "ja") return ja_community_private_desc(inputs)
	if (locale === "zh") return zh_community_private_desc(inputs)
	if (locale === "ar") return ar_community_private_desc(inputs)
	if (locale === "id") return id_community_private_desc(inputs)
	if (locale === "it") return it_community_private_desc(inputs)
	if (locale === "ru") return ru_community_private_desc(inputs)
	if (locale === "pt") return pt_community_private_desc(inputs)
	return ko_community_private_desc(inputs)
});